// 网络接口地址
// export const baseURL = "http://192.168.0.168:8088/api";
export const baseURL = 'http://150.138.90.90:8081/api'
// export const baseURL = 'http://192.168.0.195:8088/api'

// 专家、采购人对代理机构的打分指标
export const itemizedOfExpert = [
  "采购文件编制规范完整、评审方法和标准符合规定。",
  "代理机构提供必要的评审条件及配套的评审环境，并按规定对开标、评标（评审）活动进行全程录音、录像。",
  "代理机构保障评审活动不受外界干扰，禁止与评审工作无关的人员进入评审现场。参与评审人员严格执行工作纪律。",
  "采购代理机构人员未发表任何存在歧视性、倾向性的意见，未非法干预采购评审活动。",
  "代理机构人员认真核对评审结果，服务过程细致耐心、严格规范。",
];


export const itemizedOfPurch = [
  "在评审工作开始前，采购代理机构统一保管手机等通讯工具或相关电子设备。",
  "采购代理机构人员核对评审专家身份和采购人代表授权函。",
  "采购代理机构提供必要的评审条件及配套的评审环境，并按规定对评审活动进行全程录音录像。",
  "采购代理机构保障评审活动不受外界干扰。",
  "采购文件编制规范、完整，采购文件中评审方法和标准符合规定。",
  "采购代理机构人员宣布评审纪律，告知评审专家应当回避的情形，介绍政府采购相关政策法规、采购文件。",
  "采购代理机构人员未发表任何存在歧视性、倾向性的意见，未非法干预采购评审活动。",
  "采购代理机构采取必要措施禁止与评审工作无关的人员进入评审现场。",
  "采购代理机构认真核对评审结果，服务过程细致耐心、严格规范。",
  "采购代理机构采购信息发布及时，信息发布内容无错漏。",
];

// 代理机构申报信息项
export const declaration = [
  "代理机构名称、统一社会信用代码、办公场所地址、联系电话等机构信息",
  "法定代表人及专职从业人员有效身份证明等个人信息",
  "内部监督管理制度",
  "在自有场所组织评审工作的，应当提供评审场所地址、监控设备设施情况",
  "省级财政部门要求提供的其他材料",
];

// 代理机构对专家的打分指标
export const agencyToExpertQuota = [{"title":"接受评审任务后未按时参加评审工作超过30分钟（含30分钟）或早退。","score":'-1'},
{"title":"不配合工作人员进行专家身份验证。","score":'-1'},
{"title":"在参加评审活动过程中，拒绝将手机等全部通讯工具交由采购人或采购代理机构统一保管。","score":'-1'},
{"title":"不熟悉政府采购法律法规和规章制度规定。","score":'-1'},
{"title":"不具备评审相关政府采购项目所需的专业知识，不熟悉相关市场行情。","score":'-1'},
{"title":"不能围绕采购文件要求进行客观、公正打分。","score":'-2'},
{"title":"无正当理由拒不履行评审义务，拒绝在评审报告上签字。对报告有异议的，未在评审报告签署不同意见并说明理由。","score":'-2'},
{"title":"记录、复制或带走评审资料；","score":'-2'},
{"title":"接受评审任务后未参加评审活动且未按规定事先请假。","score":'-2'},
{"title":"评审期间擅离职守，影响评审程序正常进行","score":'-2'},
{"title":"在评审过程中发表倾向性、歧视性、排他性、引导性言论，明示或暗示授标意图，影响其他评审专家独立评审。","score":'-2'},
{"title":"超标准索要劳务报酬、差旅费","score":'-3'},
{"title":"评审期间不服从现场管理，影响评审程序正常进行","score":'-3'},
{"title":"在评审现场高声喧哗或随意走动","score":'-3'},
{"title":"评审时间内擅自与外界联系。","score":'-3'},
{"title":"对需要专业判断的主观评审因素协商打分。","score":'-3'},
{"title":"在评审过程中，非因法律法规规定情形而随意废标。","score":'-3'},
{"title":"迟到后未能参加评审，仍向采购代理机构或采购人索要报酬。","score":'-3'},
{"title":"发现采购文件内容违反国家强制性规定或采购文件存在歧义、重大缺陷导致评审工作无法进行时，未停止评审并向采购人或采购代理机构书面说明情况。","score":'-3'},
{"title":"对供应商投标（响应）判定为不合格投标（响应）或者对供应商报价判定为无效报价时，未详细说明理由。","score":'-3'},
{"title":"接受投标（响应）供应商提出的与投标（响应）文件不一致澄清或者说明，接受供应商口头澄清，接受无法定代表人或其授权代表签字、盖章的澄清或说明。","score":'-3'},
{"title":"故意拖延评审时间。","score":'-3'},
{"title":"出现评分畸高、畸低现象。","score":'-3'},
{"title":"出现客观分评审错误。","score":'-3'},
{"title":"对需要共同认定的事项，拒不按照少数服从多数原则做出结论。","score":'-3'},
{"title":"工作单位、需要回避的信息等事项发生变化后不及时变更","score":'-3'},
{"title":"接到采购人、采购代理机构和财政部门电话通知3次以上（含3次）或书面通知后，仍不履行配合答复供应商询问、质疑、投诉等法定义务。不配合解答采购人或政府采购监管部门对评审活动、本人评审意见的咨询，或拒不提供书面说明。","score":'-30'},
{"title":"未按照采购文件规定的评审程序、评审方法和评审标准进行独立评审。","score":'-30'},
{"title":"在采购结果公示前，泄露自己或他人应邀参加项目评审身份和参与评审项目有关信息；泄露评审文件、评审情况和评审中获悉的商业秘密","score":'-30'},
{"title":"不如实填报回避信息，或有法定回避情形而不主动提出，或明知应当回避而未主动申请回避。","score":'-30'},
{"title":"索取收受供应商、其他利害关系人贿赂或者获取其他不正当利益。","score":'-30'},
{"title":"委托他人或代替他人参加评审工作、政府采购业务培训或测试","score":'-30'},
{"title":"其他滥用评审权利、拒不履行评审义务、违反评审纪律，以及无正当理由拒绝财政部门监管，造成严重不良影响或后果。","score":'-30'},
{"title":"辱骂、恐吓、威胁财政部门人员、代理机构人员、采购人代表或者供应商。","score":'-30'},
{"title":"其他违法违规情形","score":'-1'}];

export const officeToExpertQuota = [{"title":"被财政部门约谈1次及以上","score":'-3'},
{"title":"建立或加入以政府采购专家为主体的社交媒体群，从事有损政府采购公信力活动。","score":'-30'},
{"title":"应聘、续聘提供虚假材料，获取专家资格","score":'-30'},
{"title":"未参加财政部门组织的培训或测试不合格","score":'-30'},
{"title":"聘期内被财政部门暂停随机抽取资格2次及以上","score":'-30'},
{"title":"续聘时未更新提供申请承诺书、近三年社保缴纳证明材料（已退休人员除外）。","score":'-30'},
{"title":"受到严重警告及以上的党纪处分或受到记大过及以上的政务处分；受到除警告、通报批评、罚款以外的行政处罚或受到刑事处罚。","score":'-30'},
{"title":"以政府采购评审专家身份从事有损政府采购公信力的相关活动，或者存在失德失信行为造成较大影响","score":'-30'},
{"title":"其他违法违规情形","score":'-1'},
{"title":"积极参与和配合财政部门项目论证、政策调研等，能够完成财政部门交给的具体工作，且工作卓有成效","score":'5'},
{"title":"对财政部门的日常监管工作提出合理化建议和意见，被财政部门在制定制度办法时或日常工作中采纳","score":'5'}]

export const matterArr = ["举报投诉", "处理处罚", "监督检查结果", "其他"];

// 获取当前时间、转化时间
export function getCurrentTime(time) {
  var date = new Date(time);//当前时间
  var year = date.getFullYear() //年
  var month = repair(date.getMonth() + 1);//月
  var day = repair(date.getDate());//日
  // var hour = repair(date.getHours());//时
  // var minute = repair(date.getMinutes());//分
  // var second = repair(date.getSeconds());//秒

  //当前时间
  // var curTime = year + "-" + month + "-" + day
  //   + " " + hour + ":" + minute + ":" + second;
  var curTime = year + "-" + month + "-" + day

  return curTime;
}

// 若是小于10就加个0
function repair(i) {
  if (i >= 0 && i <= 9) {
    return "0" + i;
  } else {
    return i;
  }
}